import { FC } from 'react';

import { useContractRegistrationStore } from 'page/CustomerPage/hooks';
import { ContractConfirmationModalView } from 'page/CustomerPage/components/ContractConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickRegistration: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickRegistration,
}) => {
  const {
    isOpenConfirmationModal,
    menuName,
    displayStartDate,
    displayEndDate,
  } = useContractRegistrationStore();

  return (
    <>
      {/* 契約メニューの確認モーダル */}
      <ContractConfirmationModalView
        mode="登録"
        isOpen={isOpenConfirmationModal}
        menuName={menuName}
        displayStartDate={displayStartDate}
        displayEndDate={displayEndDate}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickExecution={handleClickRegistration}
      />
    </>
  );
};
